// Module
var code = "You should return to the cafe/bar you chose in the last episode. ";
// Exports
module.exports = code;